import React, { useMemo } from 'react';
import SliderFooter from './SliderFooter';
import { useLang, useTrans } from 'utils/localisation';
import { pushCustomEvent } from 'utils/analytics';
import relatedCasesData from './related-cases.json';

import * as styles from './AsideFooter.module.scss';

function AsideFooter({ calculatorID }) {
  const t = useTrans(['pricingCalculator']);
  const lang = useLang();
  const { relatedCasesTeamAugmentation, relatedCasesCustomSoftware } = relatedCasesData;

  const relatedCases = useMemo(() => {
    if (calculatorID === 'price') {
      return relatedCasesTeamAugmentation[lang] ?? relatedCasesTeamAugmentation.en;
    }

    if (calculatorID === 'price-custom-software') {
      return relatedCasesCustomSoftware[lang] ?? relatedCasesCustomSoftware.en;
    }

    return [];
  }, [calculatorID, lang]);

  const handlePushEvent = action => {
    pushCustomEvent('ndrsn_pricing_modal', {
      action,
      label: calculatorID,
    });
  };

  return (
    <section className={styles.wrapper}>
      <SliderFooter
        title={t('relatedCasesTitle')}
        items={relatedCases}
        handlePushEvent={handlePushEvent}
      />
    </section>
  );
}

export default AsideFooter;
